import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { ErrorPage } from './ErrorPage';

export default function RouterErrorPage() {
    const error: any = useRouteError();


    let title = "Something went wrong";
    let description = "An unexpected error occurred.";
    let code: string | number = "Oops!";

    if (isRouteErrorResponse(error)) {
        code = error.status;
        title = error.statusText || "Error";
        description = error.data?.message || "We encountered an error loading this page.";
    } else if (error instanceof Error) {
        // description = error.message; // Potentially unsafe to show raw error message, but helpful for debugging
        description = error.message;

        // Check for ChunkLoadError explicitly
        if (error.name === 'ChunkLoadError' || error.message.includes('dynamically imported module') || error.message.includes('Importing a module script failed')) {
            code = "Update";
            title = "Update Required";
            description = "A new version of the application is available. We need to reload the page to apply the updates.";
        }
    }

    return (
        <ErrorPage
            code={code}
            title={title}
            description={description}
            actionLabel="Reload Page"
            onAction={() => window.location.reload()}
            showHomeButton={true}
        />
    );
}
